'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MixPanel = exports.mixpanel = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _localStorage = require('redux/saga/helpers/local-storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIXPANEL_DEBUG = false; /*
                             * ATTENTION!
                             *
                             * If you just want to track some events, please use `mp` from `helpers/multitrack`
                             */

var MIXPANEL_INIT = '(function(f,b){if(!b.__SV){var a,e,i,g;window.mixpanel=b;b._i=[];b.init=function(a,e,d){function f(b,h){var a=h.split(".");2==a.length&&(b=b[a[0]],h=a[1]);b[h]=function(){b.push([h].concat(Array.prototype.slice.call(arguments,0)))}}var c=b;"undefined"!==typeof d?c=b[d]=[]:d="mixpanel";c.people=c.people||[];c.toString=function(b){var a="mixpanel";"mixpanel"!==d&&(a+="."+d);b||(a+=" (stub)");return a};c.people.toString=function(){return c.toString(1)+".people (stub)"};i="disable track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" ");\nfor(g=0;g<i.length;g++)f(c,i[g]);b._i.push([a,e,d])};b.__SV=1.2;a=f.createElement("script");a.type="text/javascript";a.async=!0;a.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";e=f.getElementsByTagName("script")[0];e.parentNode.insertBefore(a,e)}})(document,window.mixpanel||[]);';

var mixpanelCheckTimer = void 0;
var mixpanelMethods = ['track', 'get_property', 'register', 'register_once', 'alias', 'identify'];
var mixpanelCalls = {};
var onReadyCalls = [];

function nativeMixpanel() {
  if (__CLIENT__ && window.mixpanel) {
    return window.mixpanel && window.mixpanel.__loaded ? window.mixpanel : null; // eslint-disable-line no-underscore-dangle
  }
}

function mixpanelCheck() {
  var mixpanel = nativeMixpanel();
  if (mixpanel) {
    clearInterval(mixpanelCheckTimer);
    onReadyCalls.forEach(function (func) {
      return func();
    });
    onReadyCalls.length = 0;
    mixpanelMethods.filter(function (method) {
      return mixpanelCalls[method] && mixpanelCalls[method].length > 0;
    }).forEach(function (method) {
      return mixpanelCalls[method].forEach(function (methodArguments) {
        return mixpanel[method].apply(mixpanel, (0, _toConsumableArray3.default)(methodArguments));
      });
    });
    mixpanelMethods = {};
  }
}

var mixpanelInterface = mixpanelMethods.reduce(function (mpInterface, method) {
  mpInterface[method] = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (__CLIENT__ && (0, _localStorage.readLocalStorage)('trackingDebug')) {
      var _console;

      (_console = console).info.apply(_console, ['Tracking MixPanel.' + method].concat(args)); // eslint-disable-line no-console
    }

    if (nativeMixpanel()) {
      var _nativeMixpanel;

      return (_nativeMixpanel = nativeMixpanel())[method].apply(_nativeMixpanel, args);
    }

    mixpanelCalls[method] = mixpanelCalls[method] || [];
    mixpanelCalls[method].push(args);
    if (!mixpanelCheckTimer && __CLIENT__) {
      mixpanelCheckTimer = setInterval(mixpanelCheck, 500);
    }
  };
  return mpInterface;
}, {});

mixpanelInterface.onReady = function (func) {
  if (nativeMixpanel()) {
    func();
  } else {
    onReadyCalls.push(func);
    if (!mixpanelCheckTimer && __CLIENT__) {
      mixpanelCheckTimer = setInterval(mixpanelCheck, 500);
    }
  }
};

var mixpanel = exports.mixpanel = mixpanelInterface;

var MixPanel = exports.MixPanel = function (_React$Component) {
  (0, _inherits3.default)(MixPanel, _React$Component);

  function MixPanel() {
    (0, _classCallCheck3.default)(this, MixPanel);
    return (0, _possibleConstructorReturn3.default)(this, (MixPanel.__proto__ || (0, _getPrototypeOf2.default)(MixPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(MixPanel, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this = this;

      var _props = this.props,
          currentUser = _props.currentUser,
          msa = _props.msa,
          deviceType = _props.deviceType;


      if (__CLIENT__) {
        if (!currentUser) {
          var lastCheckTime = void 0;
          try {
            lastCheckTime = parseInt(window.localStorage.getItem('lastSessionStart') || 0, 10);
          } catch (err) {
            // NOOP to catch Safari private browsing
          }

          if (lastCheckTime < Date.now() - 60 * 1e3 * 30) {
            // every 30 minutes
            mixpanel.onReady(function () {
              _this.sessionStart();
              try {
                window.localStorage.setItem('lastSessionStart', Date.now());
              } catch (err) {
                // NOOP to catch Safari private browsing
              }
            });
          }
        }

        mixpanelInterface.register({
          user_type: mixpanelInterface.get_property('user_type') || 'prospect',
          msa_id: msa ? msa.id : mixpanelInterface.get_property('msa_id'),
          msa_name: msa ? msa.name : mixpanelInterface.get_property('msa_name'),
          app_platform: 'web',
          device_type: deviceType
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Track a MP page view if the URL changes
      if (this.props.currentPath !== nextProps.currentPath) {
        mixpanel.track('mp_page_view', {
          mp_page: __CLIENT__ ? window.location.href : nextProps.currentPath
        });
      }
    }
  }, {
    key: 'sessionStart',
    value: function sessionStart() {
      if (!this.props.routes) {
        return;
      }

      mixpanelInterface.register({
        session_start_count: (mixpanelInterface.get_property('session_start_count') || 0) + 1
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var accountKey = this.props.accountKey;


      var accountInit = 'mixpanel.init(\'' + accountKey + '\');';

      if (__LOCAL_DEV__ && MIXPANEL_DEBUG) {
        accountInit = 'mixpanel.init(\'' + accountKey + '\', { debug: true });';
      }

      return _react2.default.createElement('script', {
        key: 'mixpanel-script'
        // eslint-disable-next-line react/no-danger
        , dangerouslySetInnerHTML: { __html: (MIXPANEL_INIT + accountInit).replace(/\n/g, '') }
      });
    }
  }]);
  return MixPanel;
}(_react2.default.Component);

MixPanel.propTypes = {
  accountKey: _propTypes2.default.string.isRequired,
  currentPath: _propTypes2.default.string.isRequired,
  deviceType: _propTypes2.default.string.isRequired,
  routes: _propTypes2.default.array,
  msa: _propTypes2.default.object,
  currentUser: _propTypes2.default.object
};